import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { IIconCardsList } from "@app/models/storyblok/blocks/icon-cards-list";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import {
  BlockHeader,
  HeaderLevel,
} from "../../../common/block-header/BlockHeader";
import { BlockBody } from "../../../common/block-body/BlockBody";
import { Cards } from "./components/cards/Cards";

export const IconCardsList: FC<IIconCardsList> = ({ cards, title, text }) => (
  <div
    className={classNames(
      "mt-20 flex flex-col items-center px-5",
      "lg:mt-25 lg:px-16",
      "xl:mt-40",
    )}
  >
    <div
      className={classNames(
        "space-y-15",
        "lg:max-w-container-small",
        "xl:space-y-25",
      )}
    >
      <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
        <div
          className={classNames(
            "space-y-5 text-center",
            "md:max-w-3/4 md:mx-auto",
            "lg:max-w-full",
          )}
        >
          {title ? (
            <div
              className={classNames(
                "text-medium text-primary-content",
                "lg:text-large",
                "xl:text-xx-large",
              )}
            >
              <BlockHeader richText={title} headerLevel={HeaderLevel.H2} />
            </div>
          ) : null}
          {text ? (
            <div
              className={classNames(
                "text-regular text-base-400",
                "[&>p]:mb-2.5 last:[&>p]:mb-0 [&>p]:lg:mb-5",
              )}
            >
              <BlockBody richText={text} />
            </div>
          ) : null}
        </div>
      </Fade>
      <Cards data={cards} />
    </div>
  </div>
);
